import React, { Dispatch, SetStateAction } from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

interface IRecordingOptionsModal {
  setShow: Dispatch<SetStateAction<boolean>>;
  show: boolean;
  saveToNotes: () => void;
  download: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sampleScreenshot: {
      width: '300px',
      height: '200px',
    },
    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
    },
    jobsButton: {
      backgroundColor: '#00A4EF',
      color: 'white',
      '&:hover': {
        backgroundColor: '#00A4EF',
      },
    },
  })
);

export default function RecordingOptionsModal({ setShow, show, saveToNotes, download }: IRecordingOptionsModal) {
  const classes = useStyles();
  const handleClose = () => {
    setShow(!show);
  };

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      fullWidth={true}
      maxWidth={'sm'}
      open={show}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Save Recording</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Do you want to save this Recording to the Job's note?
        </DialogContentText>
      </DialogContent>
      <DialogContent className={classes.imageContainer}></DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          className={classes.jobsButton}
          onClick={() => {
            saveToNotes();
            handleClose();
          }}
        >
          Save to Job Notes
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            handleClose();
            download();
          }}
        >
          Download to my PC
        </Button>
        <Button color="secondary" variant="contained" onClick={handleClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
